import getPromoByCoupon from 'services/api/promotions/getPromoByCoupon';

export default { getPromoByCoupon };
